<template>
	<div class="dashboard">
		
		<top-headerall></top-headerall>		
		 <!--<top-header></top-header> -->		
		<b-container fluid >
			<b-row class="mb-3">	
				<top-nevleft></top-nevleft>
				<!-- <b-col cols="3" id="sidebar-fifi-toggle" v-if="!statusSidebar">
					<top-nevleft></top-nevleft>
                    
                </b-col>-->
             <b-col>
				<b-row class="breadcrumbrow mt-1">
				
				<b-col class="text-center">
				
				 <h5 >Seller Dashboard</h5>
				
				
				
				</b-col>
				
				</b-row>
			  
			  
			 <h4 class="text-center mt-3 mb-3"><!--Welcome to Seller Dashboard --></h4>
			<b-row class="px-2">
				<!-- <b-col class="px-2">
					<b-card img-src="../../assets/icons/crm.svg" img-alt="Card image" img-left class="info-box mb-3">
						<h6>Total Customers</h6>
						<b-card-text>
							0 Nos
						</b-card-text>
					</b-card>
				</b-col>
				<b-col class="px-2">
					<b-card img-src="../../assets/icons/crm.svg" img-alt="Card image" img-left class="info-box mb-3">
						<h6>Total Agents</h6>
						<b-card-text>
							0 Nos
						</b-card-text>
					</b-card>
				</b-col>-->
					<b-col class="px-2" lg="4" md="4" sm="6" >
							<b-card no-body class="overflow-hidden p-1">
								<!-- <h6>Total Sellers</h6>
								<b-card-text>
									{{total_seller}}  <b-link block v-b-toggle.totalSeller variant="info"> - </b-link> 
								</b-card-text> -->
								<b-row no-gutters>
								 
								  <b-col cols='8'>
									<b-card-body >
										<h6>Total Products</h6>
									  <b-card-text>
											{{total_products|0}}
									  </b-card-text>
									</b-card-body>
								  </b-col>
								   <b-col cols="4"  class="text-center borderLeft pl-0">
											<b-badge pill variant="success" v-b-tooltip.hover title="Active">{{productStatus.activ}}</b-badge>
											<br/>
										<b-badge pill variant="danger" v-b-tooltip.hover title="Waiting" >{{productStatus.waiting}}</b-badge>
										
								  </b-col>
								</b-row>
								
								<footer class="card-footer p-0 mt-1">
									<b-row no-gutters>
										<b-col  class="text-center ">	
											<b-link href="/seller/products" style="font-size:12px;">
											<b-iconstack style="font-size:12px;">
											  <b-icon stacked icon="square"></b-icon>
											  <b-icon stacked icon="dot" shift-h="-3" shift-v="4"></b-icon>
											  <b-icon stacked icon="dot" shift-h="-3"></b-icon>
											  <b-icon stacked icon="dot" shift-h="-3" shift-v="-4"></b-icon>
											  <b-icon stacked icon="dot" shift-h="3" shift-v="4"></b-icon>
											  <b-icon stacked icon="dot" shift-h="3"></b-icon>
											  <b-icon stacked icon="dot" shift-h="3" shift-v="-4"></b-icon>
											</b-iconstack>
											</b-link>
										</b-col>
									   <b-col class="text-center">
											
											<b-link block v-b-toggle.totalSeller variant="info"> <i class="fa fa-caret-down" aria-hidden="true"></i> </b-link> 										
									  </b-col>
									</b-row>
										<b-collapse id="totalSeller"  accordion="my-accordion" role="tabpanel">
									<b-card-body>
									   <b-list-group >
										  <b-list-group-item>Activ : <div class="textCount" > {{productStatus.activ}}</div> </b-list-group-item>
										  <b-list-group-item>Waiting : <div class="textCount" >  {{productStatus.waiting}}  </div></b-list-group-item>
										  <b-list-group-item>Rejected :<div class="textCount" > {{productStatus.rejected}}</div></b-list-group-item>
										</b-list-group>
									</b-card-body>
							  </b-collapse>	
								</footer>
							</b-card>
				</b-col>
				<b-col class="px-2" lg="4" md="4" sm="6">
				
						<b-card no-body class="overflow-hidden p-1">
							<b-row no-gutters>
							  <b-col cols="8" >
								<b-card-body >
									<h6>Active Orders</h6>
								  <b-card-text>
										{{active_orders}}
								  </b-card-text>
								</b-card-body>
							  </b-col>
							   <b-col cols="4" class="text-center borderLeft">
									<b-badge pill variant="danger" v-b-tooltip.hover title="Fulfilled"  >{{activeOrdersList.completed[0]}}</b-badge>
									<br/>
										<b-badge pill variant="success" v-b-tooltip.hover title="Cancelled">{{activeOrdersList.cancelled[0]}}</b-badge>
										
									
							  </b-col>
							</b-row>
							<footer class="card-footer p-0 mt-1">
								<b-row no-gutters>
									<b-col  class="text-center ">	
										<b-link href="/seller/orders" style="font-size:12px;">
										<b-iconstack style="font-size:12px;">
										  <b-icon stacked icon="square"></b-icon>
										  <b-icon stacked icon="dot" shift-h="-3" shift-v="4"></b-icon>
										  <b-icon stacked icon="dot" shift-h="-3"></b-icon>
										  <b-icon stacked icon="dot" shift-h="-3" shift-v="-4"></b-icon>
										  <b-icon stacked icon="dot" shift-h="3" shift-v="4"></b-icon>
										  <b-icon stacked icon="dot" shift-h="3"></b-icon>
										  <b-icon stacked icon="dot" shift-h="3" shift-v="-4"></b-icon>
										</b-iconstack>
										</b-link>
									</b-col>
								   <b-col  class="text-center">
										
										<b-link block v-b-toggle.totalOrders variant="info"> <i class="fa fa-caret-down" aria-hidden="true"></i> </b-link> 										
								  </b-col>
								</b-row>
									<b-collapse id="totalOrders"  accordion="my-totalOrders" role="tabpanel">
									<b-card-body>
									   <b-list-group >
										  <b-list-group-item>Total Orders : <div class="textCount" > {{activeOrdersList.sales[0]}} </div> </b-list-group-item>
										  <b-list-group-item>Total Cancelled : <div class="textCount" > {{activeOrdersList.cancelled[0]}} </div></b-list-group-item>
										  <!-- <b-list-group-item>Total Returned :<div class="textCount" > 0 </div></b-list-group-item> --> 
										  <b-list-group-item>Total Fulfilled :<div class="textCount" > {{activeOrdersList.completed[0]}} </div></b-list-group-item>
										</b-list-group>
									</b-card-body>
								</b-collapse>	
							</footer>
						</b-card>

				</b-col>
				<!-- <b-col class="px-2" lg="3" md="3" sm="6">
					<b-card img-src="../../assets/icons/orders.svg" img-alt="Card image" img-left class="info-box mb-3">
						<h6>Active Orders</h6>
						<b-card-text>{{active_orders}}
						</b-card-text>
					</b-card>
				</b-col> -->
				<!-- <b-col class="px-2" lg="4" md="4" sm="6" >
					<b-card img-src="../../assets/icons/commission.svg" img-alt="Card image" img-left class="info-box mb-3">
						<h6>Total Sales</h6>
						<b-card-text>{{$root.currency()+$root.tofixed(total_sales, 2)}}</b-card-text>
					</b-card>
				</b-col> -->
					<b-col class="px-2" lg="4" md="4" sm="6" >
						<b-card no-body class="overflow-hidden p-1">
							<b-row no-gutters>
							  <b-col cols="8" >
								<b-card-body >
									<h6 class="py-2 pt-3" >Total Sales</h6>
								  <!-- <b-card-text>
									{{$root.currency()+$root.tofixed(total_sales, 2)}}

								  </b-card-text>-->
								</b-card-body>
							  </b-col>
							   <b-col cols="4" class="text-center borderLeft ">
										<div class="py-2 pt-3">{{$root.currency()+$root.tofixed(total_sales, 2)}}</div>
										
									
							  </b-col>
							</b-row>
							<footer class="card-footer p-0 mt-1">
								<b-row no-gutters>
									<b-col  class="text-center ">	
										<b-link href="/seller/orders" style="font-size:12px;">
										<b-iconstack style="font-size:12px;">
										  <b-icon stacked icon="square"></b-icon>
										  <b-icon stacked icon="dot" shift-h="-3" shift-v="4"></b-icon>
										  <b-icon stacked icon="dot" shift-h="-3"></b-icon>
										  <b-icon stacked icon="dot" shift-h="-3" shift-v="-4"></b-icon>
										  <b-icon stacked icon="dot" shift-h="3" shift-v="4"></b-icon>
										  <b-icon stacked icon="dot" shift-h="3"></b-icon>
										  <b-icon stacked icon="dot" shift-h="3" shift-v="-4"></b-icon>
										</b-iconstack>
										</b-link>
									</b-col>
								   <b-col class="text-center">
										
										<b-link block v-b-toggle.totalSales variant="info"> <i class="fa fa-caret-down" aria-hidden="true"></i> </b-link> 										
								  </b-col>
								</b-row>
									<b-collapse id="totalSales"  accordion="my-totalSales" role="tabpanel">
									<b-card-body>
									   <!-- <b-list-group >
										  <b-list-group-item>Total Earn : <div class="textCount" > ---- </div> </b-list-group-item>
										 
										</b-list-group> -->
									</b-card-body>
								</b-collapse>	
							</footer>
						</b-card>

							
							
						
					</b-col>

			</b-row>
			<b-row class="mb-3 px-2">
				<b-col class="px-2" lg="6" sm="12">
				<b-card class="p-0">
							<coupon-popup></coupon-popup>
						</b-card>
					<b-card class="p-0">
						<referafriend-popup></referafriend-popup>
					</b-card>
					<b-card class="p-0">
						<div class="card-header border-0">
							<b-row  class=" align-items-center">
								<b-col cols="12" lg="4" md="12" sm="12"><h6 class="mb-0">Sales Summary </h6></b-col> 
								<b-col cols="10" lg="7" md="10" sm="10" class="p-0"><b-button class="rounded-pill mr-2 fontSize9" size="sm" @click="summary_selected = summary.daily">Today</b-button>
								<b-button class="rounded-pill mr-2 fontSize9" size="sm" @click="summary_selected = summary.weekly">This Week</b-button>
								<b-button class="rounded-pill mr-2 fontSize9" size="sm" @click="summary_selected = summary.monthly">This Month</b-button>
								<b-button class="rounded-pill fontSize9" size="sm" @click="summary_selected = summary.all">All</b-button></b-col>
								
								<b-col cols="2" lg="1" md="2" sm="2" class="text-right pl-0"><b-link block v-b-toggle.salseSummer variant="info"> <i class="fa fa-caret-down"></i> </b-link></b-col>
								</b-row>
						</div>
					
						
						<b-collapse id="salseSummer" visible accordion="my-salseSummer" role="tabpanel">
						
						<div class="el-table table-responsive table el-table--fit el-table--scrollable-Y el-table--enable-row-hover el-table--enable-row-transition b-table-sticky-header">
						<div class="hidden-columns"><div></div><div></div><div></div></div>
							<div class="el-table__body-wrapper is-scrolling-right">
								<table cellspacing="0" cellpadding="0" border="0" class="el-table__body" style="width: 100%;">
									<colgroup>
										<col name="el-table_2_column_5" width="50%">
											<col name="el-table_2_column_6" width="30%"><col name="el-table_2_column_7" width="20%">
									</colgroup> 
									<tbody>
										<tr class="el-table__row" >
											<td rowspan="1" colspan="1" class="el-table_2_column_5  "><div class="cell"><div class="font-weight-600" style="text-transform: capitalize;">Total Sales</div></div></td>
											<td rowspan="1" colspan="1" class="el-table_2_column_6  "><div class="cell">{{summary_selected.sales[0]}}</div></td>
											<td rowspan="1" colspan="1" class="el-table_2_column_7">{{$root.currency()+$root.tofixed(summary_selected.sales[1], 2)}}</td>
										</tr>
										
										<tr class="el-table__row" >
											<td rowspan="1" colspan="1" class="el-table_2_column_5  "><div class="cell"><div class="font-weight-600" style="text-transform: capitalize;">Total Orders</div></div></td>
											<td rowspan="1" colspan="1" class="el-table_2_column_6  "><div class="cell">{{summary_selected.orders[0]}}</div></td>
											<td rowspan="1" colspan="1" class="el-table_2_column_7">{{$root.currency()+$root.tofixed(summary_selected.orders[1] ? summary_selected.orders[1]: 0, 2)}}</td>
										</tr>
										
										<tr class="el-table__row" >
											<td rowspan="1" colspan="1" class="el-table_2_column_5  "><div class="cell"><div class="font-weight-600" style="text-transform: capitalize;">Total Cancelled</div></div></td>
											<td rowspan="1" colspan="1" class="el-table_2_column_6  "><div class="cell">{{summary_selected.cancelled[0]}}</div></td>
											<td rowspan="1" colspan="1" class="el-table_2_column_7">{{$root.currency()+$root.tofixed(summary_selected.cancelled[1],2)}}</td>
										</tr>
										<tr class="el-table__row" >
											<td rowspan="1" colspan="1" class="el-table_2_column_5  "><div class="cell"><div class="font-weight-600" style="text-transform: capitalize;">Total Fulfilled</div></div></td>
											<td rowspan="1" colspan="1" class="el-table_2_column_6  "><div class="cell">{{summary_selected.completed[0]}}</div></td>
											<td rowspan="1" colspan="1" class="el-table_2_column_7">{{$root.currency()+$root.tofixed(summary_selected.completed[1],2)}}</td>
										</tr>
										
											
									</tbody>
								</table>
						</div>
						<div class="el-table__column-resize-proxy" style="display: none;"></div>
										
						</div>
						
						</b-collapse>
					</b-card>

				
				
				<!-- Inventory -->
			<div class="card" >
				<div class="card-header border-0"><div class="row align-items-center"><div class="col"><h6 class="mb-0">Inventory</h6></div><div class="text-right col">
							<b-link href="/seller/import-stock" style="font-size:12px;">
								<b-iconstack style="font-size:12px;">
								  <b-icon stacked icon="square"></b-icon>
								  <b-icon stacked icon="dot" shift-h="-3" shift-v="4"></b-icon>
								  <b-icon stacked icon="dot" shift-h="-3"></b-icon>
								  <b-icon stacked icon="dot" shift-h="-3" shift-v="-4"></b-icon>
								  <b-icon stacked icon="dot" shift-h="3" shift-v="4"></b-icon>
								  <b-icon stacked icon="dot" shift-h="3"></b-icon>
								  <b-icon stacked icon="dot" shift-h="3" shift-v="-4"></b-icon>
								</b-iconstack>
						</b-link><b-link block v-b-toggle.pinventory variant="info"> <i class="fa fa-caret-down ml-2"></i> </b-link></div></div></div>
					<b-collapse id="pinventory" visible accordion="my-pinventory" role="tabpanel">
					<div class="card-body p-0">
					<!----><!---->
						<div class="el-table table-responsive table el-table--fit el-table--scrollable-Y el-table--enable-row-hover el-table--enable-row-transition b-table-sticky-header">
							<div class="hidden-columns"><div></div><div></div><div></div></div>
							<div class="el-table__header-wrapper">
								<table cellspacing="0" cellpadding="0" border="0" class="el-table__header" style="width: 100%;">
								<colgroup>
									<col name="el-table_2_column_5" width="60%">
									<col name="el-table_2_column_6" width="20%">
									<col name="el-table_2_column_6" width="20%">
									<!--<col name="el-table_2_column_7" width="20%"> -->
									<col name="gutter" width="0"></colgroup>
										<thead class="has-gutter">
											<tr class="thead-light">
											<th colspan="1" rowspan="1" class="el-table_2_column_5 is-leaf"><div class="cell">Name</div></th>
											<th colspan="1" rowspan="1" class="el-table_2_column_6 is-leaf"><div class="cell">Sku</div></th>
											<th colspan="1" rowspan="1" class="el-table_2_column_7 is-leaf"><div class="cell">Qty</div></th>
											<!--<th colspan="1" rowspan="1" class="el-table_2_column_8 is-leaf"><div class="cell">Price</div></th> -->
											</tr>
										</thead>
									</table>
								</div>
								<div class="el-table__body-wrapper is-scrolling-right">
								<table cellspacing="0" cellpadding="0" border="0" class="el-table__body" style="width: 100%;">
								<colgroup>
									<col name="el-table_2_column_5" width="60%">
									<col name="el-table_2_column_6" width="20%">
									<col name="el-table_2_column_7" width="20%">
									<!-- <col name="el-table_2_column_8" width="20%"> -->
								</colgroup> 
								<tbody>
									<!-- <tr class="el-table__row"  v-for="item in last_orders" :key="item.id">
										<td rowspan="1" colspan="1" class="el-table_2_column_5  "><div class="cell"><div class="font-weight-600" style="text-transform: capitalize;">Product Name</div></div></td>
										<td rowspan="1" colspan="1" class="el-table_2_column_6  "><div class="cell"><div class="font-weight-600" style="text-transform: capitalize;">sku001</div></div></td>
										<td rowspan="1" colspan="1" class="el-table_2_column_7  "><div class="cell">2</div></td>-->
										<!--<td rowspan="1" colspan="1" class="el-table_2_column_8"> {{$root.currency()+$root.tofixed(item.price,2)}}</td> -->
									<!-- </tr> -->
									
								<!----></tbody></table><!----><!----></div><!----><!----><!----><!---->
								<div class="el-table__column-resize-proxy" style="display: none;"></div>
								
								</div>
								
								</div>
						</b-collapse>	
							
					</div>

					
					<!--<b-card class=" mt-3" header="Inventory">
						<b-row class="mt-3 py-1" v-for="item in product_details" :key="item.id" style="border-bottom:1px solid #e7e7e7;">
							<b-col>{{item.title}}</b-col>
							<b-col class="text-right">{{item.total_sales}}</b-col>
							<b-col class="text-right">{{$root.currency()+$root.tofixed(item.price,2)}}</b-col>
						</b-row>
					</b-card> -->
				</b-col>
				<b-col class="px-2" lg="6" sm="12">
												
					<b-card class="p-0">
						<div class="card-header border-0">
							<b-row  class=" align-items-center">
								<b-col  cols="10" lg="3" md="12" sm="12"><h6 class="mb-0">Products </h6></b-col> 
								<b-col cols="11" lg="8" md="10" sm="10" class="p-0"><b-button class="rounded-pill mr-2 fontSize9" size="sm" @click="product_selected = productSummary.most_sold">Most Sold</b-button>
								<b-button class="rounded-pill mr-1 fontSize9" size="sm" @click="product_selected = productSummary.most_cancelled">Most Cancelled</b-button>
								<b-button class="rounded-pill mr-1 fontSize9" size="sm" @click="product_selected = productSummary.most_returned">Most Returned</b-button>
								<b-button class="rounded-pill mr-1 fontSize9" size="sm" @click="product_selected = productSummary.most_fulfilled">Most Fulfilled</b-button>
								</b-col>
								
								<b-col cols="1" lg="1" md="2" sm="2" class="text-right"><b-link block v-b-toggle.salseProSummer variant="info"> <i class="fa fa-caret-down ml-2"></i> </b-link></b-col>
								</b-row>
						</div>
					
						<!--<template v-slot:header>
							<b-row>
								<b-col class="text-left">
									<h6 class="pt-1">Summary</h6>
								</b-col>
								<b-col class="text-right">
									<b-button class="mr-2 rounded-pill" size="sm">Data</b-button>
									<b-button class="rounded-pill" size="sm" >Chart 2</b-button>
								</b-col>
							</b-row>
						</template>-->
						<b-collapse id="salseProSummer" visible accordion="my-salseProSummer" role="tabpanel">
							<div class="card-body p-0">
								<!----><!---->
									<div class="el-table table-responsive table el-table--fit el-table--scrollable-Y el-table--enable-row-hover el-table--enable-row-transition b-table-sticky-header">
										<div class="hidden-columns"><div></div><div></div><div></div></div>
										<div class="el-table__header-wrapper">
											<table cellspacing="0" cellpadding="0" border="0" class="el-table__header" style="width: 100%;">
											<colgroup><col name="el-table_2_column_5" width="50%"><col name="el-table_2_column_6" width="30%"><col name="el-table_2_column_7" width="20%"><col name="gutter" width="0"></colgroup>
													<thead class="has-gutter">
														<tr class="thead-light">
														<th colspan="1" rowspan="1" class="el-table_2_column_5 is-leaf"><div class="cell">Title</div></th>
														<th colspan="1" rowspan="1" class="el-table_2_column_6 is-leaf"><div class="cell">SKU</div></th>
														<th colspan="1" rowspan="1" class="el-table_2_column_7 is-leaf"><div class="cell">Count</div></th>
														</tr>
													</thead>
												</table>
											</div>
											<div class="el-table__body-wrapper is-scrolling-right">
											<table cellspacing="0" cellpadding="0" border="0" class="el-table__body" style="width: 100%;">
											<colgroup>
												<col name="el-table_2_column_5" width="50%">
													<col name="el-table_2_column_6" width="30%"><col name="el-table_2_column_7" width="20%">
											</colgroup> 
											<tbody>
												 <!--{{product_selected}}
												{{productSummary}} -->
												<tr class="el-table__row"  v-for="(itemAcUse, index) in product_selected" :key="itemAcUse">
													<td rowspan="1" colspan="1" class="el-table_2_column_5  "><div class="cell"><div class="font-weight-600" style="text-transform: capitalize;">{{itemAcUse[0].title}} </div></div></td>
													<td rowspan="1" colspan="1" class="el-table_2_column_6  "><div class="cell">{{index}}</div></td>
													<td rowspan="1" colspan="1" class="el-table_2_column_7">{{itemAcUse.length}}</td>
												</tr> 
												
												
											<!----></tbody></table><!----><!----></div><!----><!----><!----><!---->
											<div class="el-table__column-resize-proxy" style="display: none;"></div>
											
											</div>
											
											</div>

						
						</b-collapse>
					</b-card>

				
				
				
					<!--<b-card header="Products">
						<b-row>
							<b-col class="text-right">
								<b-button class="rounded-pill mr-2 selected" size="sm">Most Sold</b-button>
								<b-button class="rounded-pill mr-2" size="sm">High Rated</b-button>
								<b-button class="rounded-pill mr-2" size="sm">Most Cancelled</b-button>
							</b-col>
						</b-row>
						<b-row class="mt-3 py-1" v-for="item in product_details" :key="item.id" style="border-bottom:1px solid #e7e7e7;">
							<b-col>{{item.title}}</b-col>
							<b-col class="text-right">{{item.total_sales}}</b-col>
							<b-col class="text-right">{{$root.currency()+$root.tofixed(item.price,2)}}</b-col>
						</b-row>
					</b-card> --> 
				<div class="card"><!---->
					<div class="card-header border-0"><div class="row align-items-center"><div class="col"><h6 class="mb-0">Last Orders</h6></div><div class="text-right col">
								<b-link href="/seller/orders" style="font-size:12px;">
									<b-iconstack style="font-size:12px;">
									  <b-icon stacked icon="square"></b-icon>
									  <b-icon stacked icon="dot" shift-h="-3" shift-v="4"></b-icon>
									  <b-icon stacked icon="dot" shift-h="-3"></b-icon>
									  <b-icon stacked icon="dot" shift-h="-3" shift-v="-4"></b-icon>
									  <b-icon stacked icon="dot" shift-h="3" shift-v="4"></b-icon>
									  <b-icon stacked icon="dot" shift-h="3"></b-icon>
									  <b-icon stacked icon="dot" shift-h="3" shift-v="-4"></b-icon>
									</b-iconstack>
							</b-link><b-link block v-b-toggle.latestOrder variant="info"> <i class="fa fa-caret-down ml-2"></i> </b-link></div></div></div>
					<b-collapse id="latestOrder" visible accordion="my-latestOrder" role="tabpanel">
						<div class="card-body p-0">
						<!----><!---->
							<div class="el-table table-responsive table el-table--fit el-table--scrollable-Y el-table--enable-row-hover el-table--enable-row-transition b-table-sticky-header">
								<div class="hidden-columns"><div></div><div></div><div></div></div>
								<div class="el-table__header-wrapper">
									<table cellspacing="0" cellpadding="0" border="0" class="el-table__header" style="width: 100%;">
									<colgroup>
										<col name="el-table_2_column_5" width="30%">
										<col name="el-table_2_column_6" width="35%">
										<col name="el-table_2_column_6" width="15%">
										<col name="el-table_2_column_7" width="20%">
										<col name="gutter" width="0"></colgroup>
											<thead class="has-gutter">
												<tr class="thead-light">
												<th colspan="1" rowspan="1" class="el-table_2_column_5 is-leaf"><div class="cell">SKU</div></th>
												<th colspan="1" rowspan="1" class="el-table_2_column_6 is-leaf"><div class="cell">Date</div></th>
												<th colspan="1" rowspan="1" class="el-table_2_column_7 is-leaf"><div class="cell">Qty</div></th>
												<th colspan="1" rowspan="1" class="el-table_2_column_8 is-leaf"><div class="cell">Price</div></th>
												</tr>
											</thead>
										</table>
									</div>
									<div class="el-table__body-wrapper is-scrolling-right">
									<table cellspacing="0" cellpadding="0" border="0" class="el-table__body" style="width: 100%;">
									<colgroup>
										<col name="el-table_2_column_5" width="30%">
										<col name="el-table_2_column_6" width="35%">
										<col name="el-table_2_column_7" width="15%">
										<col name="el-table_2_column_8" width="20%">
									</colgroup> 
									<tbody>
										<tr class="el-table__row"  v-for="item in last_orders" :key="item.id">
											<td rowspan="1" colspan="1" class="el-table_2_column_5  "><div class="cell"><div class="font-weight-600" style="text-transform: capitalize;">{{item.sku}}</div></div></td>
											<td rowspan="1" colspan="1" class="el-table_2_column_6  "><div class="cell"><div class="font-weight-600" style="text-transform: capitalize;">{{$moment(item.created_at).format('DD-MM-YYYY')}}</div></div></td>
											<td rowspan="1" colspan="1" class="el-table_2_column_7  "><div class="cell">{{item.total_items}}</div></td>
											<td rowspan="1" colspan="1" class="el-table_2_column_8"> {{$root.currency()+$root.tofixed(item.price,2)}}</td>
										</tr>
										
									<!----></tbody></table><!----><!----></div><!----><!----><!----><!---->
									<div class="el-table__column-resize-proxy" style="display: none;"></div>
									
									</div>
									
									</div>
							</b-collapse>	
								
						</div>

					<!-- <b-card class=" mt-3" header="Last Orders">
						<b-row class="mt-3 py-1" v-for="item in last_orders" :key="item.id" style="border-bottom:1px solid #e7e7e7;">
							<b-col cols="8">{{item.created_at}}</b-col>
							<b-col class="text-right">{{item.price}}</b-col>
							<b-col class="text-right">{{$root.currency()+$root.tofixed(item.price,2)}}</b-col>
						</b-row>
					</b-card> -->
				</b-col>
			</b-row>
			<!-- <b-row style="display:none;">
				<b-col>
					<b-card header="Monthly Sales">
						<line-chart ref="commisionchart" :height="height"/>
					</b-card>
				</b-col>
				<b-col>
					<b-card header="Monthly Orders">
						<bar-chart ref="orderschart" :height="height"/>
					</b-card>
				</b-col>
			</b-row> -->
			<set-password></set-password>
			<top-footer></top-footer>
			</b-col>
		</b-row>
		</b-container>
		
	</div>
</template>
<script>
 import Headerall from "@/components/header.vue";
//import Header from "@/components/seller/Header.vue";
import TreeviewPage from "@/components/seller/nevleft.vue";
import Footer from "@/components/footer-admin.vue";
//import { Line, Bar } from 'vue-chartjs';
import Setpassword from "@/components/setpassword.vue";
import Referafriendpopup from "@/components/referafriend-popup.vue";
import Couponpopup from "@/components/coupon-popup.vue";

export default {
	name: 'Dashboard',
	beforeCreate: function() {
        document.body.className = 'home';
    },
	components: {
		"top-headerall": Headerall,
		//"top-header": Header,	
		"top-nevleft": TreeviewPage,	
		"top-footer": Footer,
		//"line-chart": Line,
		//"bar-chart": Bar
		"set-password": Setpassword,
		"referafriend-popup": Referafriendpopup,
		"coupon-popup": Couponpopup,
	},
	mounted(){
		this.initload();
		/*this.$refs.commisionchart.renderChart({
			labels: ['January', 'February', 'March', 'April', 'May', 'June'],
			datasets: [
				{
					label: ' Sales',
					backgroundColor: '#66c2ff',
					data: [58275, 51025, 46520, 53562, 55862, 60357]
				},{
					label: 'Orders',
					backgroundColor: '#66c2ff',
					data: [58240, 51005, 42520, 53562, 52862, 66357]
				}
			]},{
			responsive: true
		});
		this.$refs.orderschart.renderChart({
			labels: ['January', 'February', 'March', 'April', 'May', 'June'],
			datasets: [
				{
					label: ' Total',
					backgroundColor: '#ffcc00',
					data: [159, 145, 151, 137, 142, 142]
				},
				{
					label: ' Fulfilled',
					backgroundColor: '#00cc66',
					data: [154,135, 142, 125, 134, 139]
				},
				{
					label: ' Canceled',
					backgroundColor: '#ff3300',
					data: [15, 50, 19, 32, 18, 13]
				}
			]},{
			scales: {
				yAxes: [{
				ticks: {
				beginAtZero: true
				},
				gridLines: {
				display: true
				}
				}],
				xAxes: [ {
				gridLines: {
				display: false
				}
				}]
				},
				legend: {
				display: true
				},
			responsive: true
		});*/
		var chagePassword = this.$route.params.activenew;
			if(chagePassword=='setpassword'){
				console.log('chagePassword:setpassword-'+chagePassword);
				this.$root.$emit('bv::show::modal', 'setpassword');
			}
			
			//this.$root.$emit('bv::show::modal', 'diwalipopup');
		
	},
	data() {
		return{
			total_users: 0,
			total_orders: 0,
			active_orders: 0,
			total_sales: 0,
			total_products: 0,
			product_details: [],
			last_orders: [],
			summary_selected: {
				sales: [0,0],
				orders: [0,0],
				cancelled: [0,0],
				completed: [0,0]
			},
			summary: {},
            height:140,
			url: this.$root.WEBAPI+'sellerapi/dashboard',
			statusSidebar: false,
			product_selected:[],
			productSummary:[],
			productStatus:[],
			activeOrdersList:{
				sales: [0,0],
				orders: [0,0],
				cancelled: [0,0],
				completed: [0,0]
			},
		};
	},
	computed: {
		/* contentStatusSidebar() {
		  return this.statusSidebar ? 'sidebarhide' : 'sidebarshow';
		},*/
	},
	methods: {
	burgerMenuSidebar() {
		  this.statusSidebar = !this.statusSidebar;
		},
		initload(){
			var self = this;
			self.axios.post(self.url, {
				accesskey: self.$session.get('access_key')
			})
			.then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
					self.total_orders = response.data.result.total_orders;
					self.total_products = response.data.result.total_products;
					self.total_sales = response.data.result.total_sales;
					self.active_orders = response.data.result.active_orders;
					self.summary = response.data.result.summary;
					self.summary_selected = self.summary.daily;
					self.activeOrdersList = self.summary.all;
					
					self.productSummary = response.data.result.productList;
					self.product_selected = self.productSummary.most_sold;
					
					self.productStatus = response.data.result.productStatus;
					
					//console.log('jay:'+response.data.result.productList);

					self.product_details = response.data.result.product_details;
					//self.last_orders = response.data.result.lastorders;
					var last_orders = response.data.result.lastorders;
					
					last_orders.forEach((item) => {
								
									var order_items =JSON.parse(item.order_items);
									//console.log('order_items'+order_items[0].title);
									//console.log('order_items'+item.order_items);
									var oI ={'price':item.price,
										'total_items':item.total_items,
										'created_at':item.created_at,
										'product_name':order_items[0].title,
										'sku':order_items[0].sku
										};
									
									self.last_orders.push(oI);
								
							});
					
					//console.log(self.last_orders);
					
					/*

					self.dashboard_data = response.data.result;
					self.records = response.data.result.records;
					self.zones = response.data.result.zones;*/

				}else if(response.data.error == 9){
					self.$root.forceLogout(response.data.message);
				}
				
			})
			.catch(function (error) {
				alert(error);
			});
		}
	}
}
</script>
<style scoped lang="scss">
.dashboard{
	.borderLeft{
		border-left: 1px solid #c6c6c682;
	}
	.list-group{
		&-item{
			padding:5px;
			font-size:12px;
			.textCount{float: right;
						width: 50%;}
		}
	}
	.fontSize9{font-size: 9px;}
}
</style>